module.exports = __webpack_public_path__ + "img/1.12a6247a.jpg";